<template>
  <transition @enter="afterEnter" @before-enter="beforeEnter">
    <div class="move_dot" ref="ball" v-if="show">
      <!-- 小球图片 -->
      <img :src="dropImage" alt="" />
    </div>
  </transition>
</template>

<script>
export default {
  props: ['dropImage'],
  data() {
    return {
      elLeft: 0,
      elTop: 0,
      show: false // 是否开始起飞
    };
  },
  mounted() {
    this.init();
    // this.elLeft = event.target.getBoundingClientRect().left;
    //     this.elTop = event.target.getBoundingClientRect().top;
    // console.log();
  },
  methods: {
    addToCart(target) {
      const _target = target.$el.getBoundingClientRect();
      this.elLeft = _target.left;
      this.elTop = _target.top;
      this.show = true;
    },
    init() {
      // const target = document.getElementById('buycar');
      // this.elLeft = target.getBoundingClientRect().left;
      // this.elTop = target.getBoundingClientRect().top;
    },
    beforeEnter(el) {
      // 设置transform值
      el.style.transform = `translate3d(0px,0px , 0)`;
      // 设置透明度
      el.style.opacity = 0;
    },
    afterEnter(el) {
      // 获取底部购物车徽标的位置
      const badgePosition = document.getElementById('buycar').getBoundingClientRect();

      // 设置位移
      el.style.transform = `translate3d(${badgePosition.left -
        this.elLeft -
        badgePosition.height}px,${badgePosition.top - this.elTop - badgePosition.width}px,0) scale(0.2, 0.2)`;
      // 增加贝塞尔曲线
      el.style.webkitTransform = `translate3d(${badgePosition.left -
        this.elLeft -
        badgePosition.height}px,${badgePosition.top - this.elTop - badgePosition.width}px,0) scale(0.2, 0.2)`;

      el.style.transition = 'transform .6s cubic-bezier(0.3, -0.25, 0.7, -0.15)';
      el.style.transition = 'transform .6s linear';

      el.style.transition = '-webkit-transform .6s cubic-bezier(0.3, -0.25, 0.7, -0.15)';
      el.style.transition = '-webkit-transform .6s linear';

      this.show = false;
      // 设置透明度
      el.style.opacity = 1;

      el.addEventListener('transitionend', () => {
        el.style.display = 'none';
        this.listenInCart();
      });
      el.addEventListener('webkitAnimationEnd', () => {
        el.style.display = 'none';
        this.listenInCart();
      });
    },
    listenInCart() {
      const { classList } = document.getElementById('buycar');
      // 拿到购物车的DOM添加class
      if (classList) classList.add('moveToCart');
      setTimeout(() => {
        // 500毫秒后移除class
        if (classList) classList.remove('moveToCart');
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped>
.move_dot {
  img {
    width: 72px;
    height: 72px;
  }
}
</style>
